import React, { Component } from "react";
import { connect } from "react-redux";
import { noImg } from "vrcore-dashboard/dist/utilities";
import {
    Card,
    CardHeader,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { selectReport } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import data from "./data.json";

import ReactToPrint from "react-to-print";
import styled from "styled-components";
import "../reports.css";

const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";

class SiteAudit extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];
        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
            checks: data,
        };
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uprn,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderYesNo = (key, value = false) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%" }}
                >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                </Select>
            );
        } else {
            return value;
        }
    };
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={
                                photo.photo_url === undefined ||
                                photo.photo_url === null ||
                                photo.photo_url === ""
                                    ? noImg
                                    : photo.photo_url
                            }
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: "auto",
                                margin: "0 auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        //let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let rYN = this.renderYesNo;
        let gstyle = gridStyle;
        let cstyle = cellStyle;

        const { report } = this.state;
        return (
            <Card>
                <CardHeader title={"Site Audit Report"} />
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Site Audit - " +
                                this.props.match.params.report_id
                                    .replace(/_/g, " ")
                                    .replace(/\./g, ":");
                        }}
                        onAfterPrint={() => {
                            document.title = this.state.title;
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        Site Audit Report
                                    </Typography>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Report Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Job Quote</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {rT("job_quote", report.job_quote)}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Auditor(s)</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {rT("auditors", report.auditors)}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Job ID:</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {rT("job_id", report.job_id)}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>Announced?</b>
                                        </div>
                                        <div style={cstyle(3, 10, 3, 13, true)}>
                                            {rT("annouced", report.announced)}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Timestamp:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 13, true)}>
                                            {report.timestamp
                                                ? report.timestamp
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Checklist</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Daily Worksheet</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {rYN(
                                                "daily_worksheet",
                                                report.daily_worksheet
                                            )}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Health & Safety Induction</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {rYN(
                                                "health_and_safety_induction",
                                                report.health_and_safety_induction
                                            )}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>SSWP</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {rYN("sswp", report.sswp)}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>PPE Inspection</b>
                                        </div>
                                        <div style={cstyle(3, 10, 3, 13, true)}>
                                            {rYN(
                                                "ppe_inspection",
                                                report.ppe_inspection
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Confined Space Permit</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 7, true)}>
                                            {rYN(
                                                "confined_space_permit",
                                                report.confined_space_permit
                                            )}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13)}>
                                            <b>Vehicle Checklist</b>
                                        </div>
                                        <div style={cstyle(4, 10, 4, 13, true)}>
                                            {rYN(
                                                "vehicle_checklist",
                                                report.vehicle_checklist
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                7,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Vehicle Details</b>
                                        </div>
                                        <div
                                            style={cstyle(
                                                1,
                                                7,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Staff Documents</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Vehicle Detail 1:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {rT(
                                                "vehicle_details_1",
                                                report.vehicle_details_1
                                            )}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Vehicle Detail 2:</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {rT(
                                                "vehicle_details_2",
                                                report.vehicle_details_2
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Vehicle Detail 3:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 7, true)}>
                                            {rT(
                                                "vehicle_details_3",
                                                report.vehicle_details_3
                                            )}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Safe Pass</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {rT("safe_pass", report.safe_pass)}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>Working at Heights</b>
                                        </div>
                                        <div style={cstyle(3, 10, 3, 13, true)}>
                                            {rT(
                                                "working_at_heights",
                                                report.working_at_heights
                                            )}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13)}>
                                            <b>Confined Space</b>
                                        </div>
                                        <div style={cstyle(4, 10, 4, 13, true)}>
                                            {rT(
                                                "confined_space",
                                                report.confined_space
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Job Description</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "job_description",
                                                report.job_description
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Staff On Site</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "staff_on_site",
                                                report.staff_on_site
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Site Set Up</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "site_setup",
                                                report.site_setup
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>PPE</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT("ppe", report.ppe)}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Were Proceedures Followed</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "were_procedures_followed",
                                                report.were_procedures_followed
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Equipment</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13)}>
                                            Is all equipment certified and up to
                                            date?
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            {rYN(
                                                "equipment_certified",
                                                report.equipment_certified
                                            )}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 13)}>
                                            Does everyone have a gas monitor?
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            {rYN(
                                                "gas_masks_present",
                                                report.gas_masks_present
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Any Non Conformance</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "non_conformancies",
                                                report.non_conformances
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={gstyle(4, 9)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Attached Photo's</b>
                                        </div>
                                        {report.attached_photos &&
                                            this.renderPhotos(
                                                report.attached_photos
                                            )}
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>
                                                Comments/Recommendations/Corrective
                                                Actions
                                            </b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "comments_recomendations",
                                                report.comments_recommendations
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store) };
    },
    { getReport, setReport, getJobPackReports }
)(SiteAudit);
